import { createSlice, Slice } from '@reduxjs/toolkit';
import { cloneDeep, merge } from 'lodash';
import { STATUS_TYPES } from '../constants/store.constants';
import { CircularProductTypes } from '../constants/common';

export const ACTION_TYPES = {
  SET_ACTIVE_PRODUCT_TAB: 'product/setActiveProductTab',
  SET_LINEAR_PRODUCT_DATA: 'product/setLinearProductData',
  SET_CIRCULAR_PRODUCT_DATA: 'product/setCircularProductData',
  SET_ERROR: 'product/setError',
  START_LOADING: 'product/startLoading',
  STOP_LOADING: 'product/stopLoading',
};

export const productSlice: Slice = createSlice({
  name: 'product',
  initialState: {
    data: {
      [CircularProductTypes.LINEAR]: null,
      [CircularProductTypes.REFURBISHED]: null,
      [CircularProductTypes.REPACKED]: null,
      [CircularProductTypes.REMANUFACTURED]: null,
    },
    activeProductTab: CircularProductTypes.LINEAR,
    status: STATUS_TYPES.IDLE,
    error: null,
    lastActionType: null,
  },
  reducers: {
    setLinearProductData(state, action) {
      const newState = cloneDeep(state);
      newState.data[CircularProductTypes.LINEAR] = merge(
        {},
        newState.data[CircularProductTypes.LINEAR],
        action.payload,
      );
      newState.lastActionType = action.type;

      return newState;
    },
    setCircularProductData(state, action) {
      const newState = cloneDeep(state);
      const { circularType, ...restPayload } = action.payload;
      newState.data[circularType] = merge({}, newState.data[circularType], restPayload);
      newState.status = STATUS_TYPES.SUCCEEDED;
      newState.error = null;
      newState.lastActionType = action.type;

      return newState;
    },
    setActiveProductTab(state, action) {
      return {
        ...state,
        activeProductTab: action.payload,
        lastActionType: action.type,
      };
    },
    startLoading(state, action) {
      return {
        ...state,
        status: STATUS_TYPES.LOADING,
        lastActionType: action.type,
      };
    },

    setError(state, action) {
      return {
        ...state,
        status: STATUS_TYPES.FAILED,
        error: action.payload,
        lastActionType: action.type,
      };
    },
    stopLoading(state, action) {
      return {
        ...state,
        status: state.status === STATUS_TYPES.LOADING ? STATUS_TYPES.IDLE : state.status,
        lastActionType: action.type,
      };
    },
  },
});

export const {
  setActiveProductTab,
  setLinearProductData,
  startLoading,
  setCircularProductData,
  setError,
  stopLoading,
} = productSlice.actions;
